import { z } from 'zod';
import { boardAddressSchema, cardAddressSchema } from './board';
import { ulidSchema } from './id';

export const permalinkParamsSchema = z.strictObject({
  id: ulidSchema,
});

export const permalinkResponseSchema = z.strictObject({
  target: z.enum(['comment', 'activity']),
  targetType: z.enum(['card', 'board']),
  targetStatus: z.enum(['available', 'deleted']),
  commentId: ulidSchema.optional(),
  activityId: ulidSchema.optional(),
  activityType: z.string().min(1).max(32).optional(),
  createdAt: z.string(),
  board: boardAddressSchema,
  card: cardAddressSchema.optional(),
});

export type PermalinkResponse = z.infer<typeof permalinkResponseSchema>;
